import { Rule } from "@fairfleet/geotab";
import RulesAddinData from "../models/RulesAddinData";

export default function combineRulesData(addinData: RulesAddinData[], rulesData: Rule[]) {
  return rulesData.map(rule => {
    const addIn = addinData.find(a => a.ruleId === rule.id);

    return {
      ruleId: rule.id,
      name: rule.name,
      pmTitle: addIn?.pmTitle ?? "",
      pmDescription: addIn?.pmDescription ?? "",
    };
  });
}
